import React, {Component} from "react";

import {Text} from "@amzn/stencil-react-components/text";

export const DETAIL_TITLE_NUMBER_SIZE = "T400";
export const DETAIL_TITLE_NUMBER_WEIGHT = "bold";

export class GenericDetailTitle extends Component {
  render() {
    return (
      <Text fontSize="T300" fontWeight="medium">
        {this.props.title}
      </Text>
    );
  }
}
